import { render, staticRenderFns } from "./PCSystemError.vue?vue&type=template&id=7c667c94&scoped=true"
import script from "./PCSystemError.vue?vue&type=script&lang=js"
export * from "./PCSystemError.vue?vue&type=script&lang=js"
import style0 from "./PCSystemError.vue?vue&type=style&index=0&id=7c667c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c667c94",
  null
  
)

export default component.exports